import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
const AemLanguageContext = React.createContext([]);
export const AemLanguagesProvider = ({ children, model }) => {
    return _jsx(AemLanguageContext.Provider, { value: model, children: children });
};
export const useAemLanguagesModel = () => {
    return useContext(AemLanguageContext);
};
